module.exports = __webpack_public_path__ + "img/72_5.cf1b12f5.png";